<template>
  <div>
    <a-input-search
      class="searchInputTeam"
      :placeholder="truenamePlaceholder"
      @search="onSearch"
    />
    <div
      v-if="userVisible"
      class="search-user-div"
    >
      <span class="searchuser-title">成员</span>
      <ul>
        <li
          v-for="(userItem,userIndex) in searchResultList"
          :key="userIndex"
          :class="userItem.defaultClass"
          @click="handleMemberManage(userItem,userIndex)"
        >
          <i class="iconfont iconicon-test80" />
          <span>{{ userItem.truename }}</span>
        </li>
      </ul>
    </div>
    <div class="tree-content-div">
      <a-tree
        v-if="!userVisible&&treeDatas.length"
        class="tree-content"
        show-icon
        default-expand-all
        :tree-data="treeDatas"
        :default-selected-keys="treeDefaultKeyLocal"
        @select="onSelect"
      >
        <i
          slot="treeNodeIcon"
          class="iconfont iconicon-test79"
        />
        <i
          slot="parentTreeNodeIcon"
          class="iconfont iconicon-test26"
        />
      </a-tree>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
      // selectedKeys: [],
      treeDefaultKeyLocal: [],
      userVisible: false,
      searchResultList: [],
      selectUserClass: 'select-user-default'
    }
  },
  computed: {
    ...mapState('team/manage', ['treeDatas', 'treeUserSearch', 'treeDefaultKey', 'inviteNewMemberVisible']),
    truenamePlaceholder () {
      return this.$t('message["790"]')
    }
  },
  watch: {
    treeDefaultKey (val) {
      if (!val) return
      this.$set(this.treeDefaultKeyLocal, 0, val[0])
    },
    treeUserSearch (val) {
      if (!val) return
      let tempv = JSON.parse(JSON.stringify(val))
      tempv.map(value => {
        value.defaultClass = 'select-user-default'
      })
      this.searchResultList = tempv
    }
  },
  mounted () {
    if (this.treeDatas.length > 0) {
      const [item] = this.treeDatas
      this.changeTreeDefaultKey([`${item.key}`])
    }
  },
  methods: {
    ...mapActions('team/member', ['changMemberVisible']),
    ...mapActions('team/manage', ['changeTeamItemName', 'fetchSearchUsersDatas', 'changeTreeDefaultKey', 'changeTreeKeyName', 'getMembersBySelectId']),
    // 昵称搜索
    onSearch (value, event) {
      if (!value) {
        this.userVisible = false
        return
      }
      this.userVisible = true
      this.fetchSearchUsersDatas({ truename: value })
    },
    handleMemberManage (item, index) {
      item.defaultClass = 'select-user-active'
      this.defaultMemberClass(item)
      this.changMemberVisible({ state: true, key: item.userid })
    },
    defaultMemberClass (item) {
      let tempv = JSON.parse(JSON.stringify(this.searchResultList))
      tempv.map(value => {
        if (item.userid === value.userid) {
          value.defaultClass = 'select-user-active'
        } else {
          value.defaultClass = 'select-user-default'
        }
      })
      this.searchResultList = tempv
    },
    // 树选中操作
    onSelect (key, e) {
      key = key.length > 0 ? key : [e.node.dataRef.key]
      this.getMembersBySelectId({ key, name: e.node.title })
    }
  }
}
</script>
<style lang="scss">
.select-user-active {
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  color: #fff;
  background-color: #5077aa;
  span {
    height: 32px;
    line-height: 32px;
  }
  i {
    color: #fff;
    margin-left: 12px;
    margin-right: 4px;
    vertical-align: middle;
  }
}
.select-user-default {
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  span {
    height: 32px;
    line-height: 32px;
  }
  i {
    color: gray;
    margin-left: 12px;
    margin-right: 4px;
    vertical-align: middle;
  }
}
.searchInputTeam {
  .ant-input {
    margin: 24px;
    width: 200px !important;
  }
  .ant-input-suffix {
    i {
      margin-left: -32px !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.tree-content {
  margin-left: 24px;
  margin-right: 24px;
}
.search-user-div {
  height: 700px;
  margin-left: 24px;
  margin-right: 24px;
  overflow: auto;
  li {
    margin-left: 40px;
    margin-top: 12px;
    margin-bottom: 12px;
    cursor: pointer;
  }
}
.tree-content-div{
  width:248px;
  overflow: hidden;
}
.graycolor {
  color: gray;
}
.searchuser-title {
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #333333;
  margin-left: 32px;
  margin-top: 4px;
  display: inline-block;
  margin-bottom: 4px;
}
</style>
